import { actionType } from "../utils/helpers/generalHelper";
import * as DocumentConstants from "../constants/document.constant";
import * as ModalConstants from "../constants/modal.constant";
import DocumentService from "../services/document.service";
import ErrorHelper from "../utils/helpers/errorHelper";
import { toast } from "react-hot-toast";
import ModalTypesEnum from "../utils/mapper/enums/ModalTypesEnum";

export const fetchAllDocumentInstructions = () => async (dispatch) => {
  try {
    dispatch(actionType(DocumentConstants.FETCH_ALL_INSTRUCTIONS_REQUEST));
    const data = await DocumentService.fetchAllDocumentInstructions();
    if (data.status !== 200) {
      throw data;
    }
    const responseData = data.data;
    dispatch(
      actionType(DocumentConstants.FETCH_ALL_INSTRUCTIONS_SUCCESS, responseData)
    );
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(DocumentConstants.FETCH_ALL_INSTRUCTIONS_FAILURE));
    toast.error(message);
  }
};

export const addDocumentInstruction =
  (documentType, payload) => async (dispatch) => {
    try {
      dispatch(actionType(DocumentConstants.ADD_INSTRUCTIONS_REQUEST));
      const data = await DocumentService.addDocumentInstructions(
        documentType,
        payload
      );
      if (data.status !== 200) {
        throw data;
      }
      const responseData = data.data;
      dispatch(
        actionType(DocumentConstants.ADD_INSTRUCTIONS_SUCCESS, responseData)
      );
    } catch (error) {
      let message = ErrorHelper.getApiErrorMessage(error);
      dispatch(actionType(DocumentConstants.ADD_INSTRUCTIONS_FAILURE));
      toast.error(message);
    }
  };

export const fetchDocumentInstructions = (documentType) => async (dispatch) => {
  try {
    dispatch(
      actionType(DocumentConstants.FETCH_DOCUMENT_TYPE_INSTRUCTION_REQUEST)
    );
    const data = await DocumentService.fetchDocumentInstructions(documentType);
    if (data.status !== 200) {
      throw data;
    }
    const responseData = data.data;
    dispatch(
      actionType(
        DocumentConstants.FETCH_DOCUMENT_TYPE_INSTRUCTION_SUCCESS,
        responseData
      )
    );
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(
      actionType(DocumentConstants.FETCH_DOCUMENT_TYPE_INSTRUCTION_FAILURE)
    );
    toast.error(message);
  }
};

export const fetchDocumentList = () => async (dispatch) => {
  try {
    dispatch(actionType(DocumentConstants.FETCH_DOCUMENT_LIST_REQUEST));
    const data = await DocumentService.getDocumentList();
    if (data.status !== 200) {
      throw data;
    }
    const responseData = data.data;
    dispatch(
      actionType(DocumentConstants.FETCH_DOCUMENT_LIST_SUCCESS, responseData)
    );
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(DocumentConstants.FETCH_DOCUMENT_LIST_FAILURE));
    toast.error(message);
  }
};

export const getUserDocuments = () => async (dispatch) => {
  try {
    dispatch(actionType(DocumentConstants.FETCH_USER_DOCUMENTS_REQUEST));
    const data = await DocumentService.getUserDocumentList();
    if (data.status !== 200) {
      throw data;
    }
    const responseData = data.data;
    dispatch(
      actionType(DocumentConstants.FETCH_USER_DOCUMENTS_SUCCESS, responseData)
    );
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(DocumentConstants.FETCH_USER_DOCUMENTS_FAILURE));
    toast.error(message);
  }
};

export const getDocument = (id) => async (dispatch) => {
  try {
    dispatch(actionType(DocumentConstants.FETCH_DOCUMENT_REQUEST));
    const data = await DocumentService.getDocument(id);
    console.log("data ", data);
    if (data.status !== 200) {
      throw data;
    }
    const responseData = data.data;
    dispatch(
      actionType(DocumentConstants.FETCH_DOCUMENT_SUCCESS, responseData)
    );
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(DocumentConstants.FETCH_DOCUMENT_FAILURE));
    toast.error(message);
  }
};

export const processUserDocument = (payload, desc) => async (dispatch) => {
  try {
    dispatch(actionType(DocumentConstants.PROCESS_DOCUMENT_REQUEST));
    const data = await DocumentService.processDocument(payload);
    if (data.status !== 201) {
      throw data;
    }
    const responseData = data.data;
    dispatch(
      actionType(DocumentConstants.PROCESS_DOCUMENT_SUCCESS, responseData)
    );
    dispatch(
      actionType(ModalConstants.SHOW_MODAL, {
        data: desc,
        type: ModalTypesEnum.DOCUMENT_REQUEST,
      })
    );
    toast.success("Document processing request successful");
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(DocumentConstants.PROCESS_DOCUMENT_FAILURE));
    toast.error(message);
  }
};

export const getDocumentProcessingFee =
  (payload, navigate) => async (dispatch) => {
    try {
      dispatch(actionType(DocumentConstants.PROCESSING_FEE_REQUEST));
      const data = await DocumentService.getProcessingFee(payload);
      console.log({ data });
      if (data.status !== 200) {
        throw data;
      }
      const responseData = data.data;
      dispatch(
        actionType(DocumentConstants.PROCESSING_FEE_SUCCESS, responseData)
      );
      navigate();
    } catch (error) {
      let message = ErrorHelper.getApiErrorMessage(error);
      dispatch(actionType(DocumentConstants.PROCESSING_FEE_FAILURE));
      toast.error(message);
    }
  };

export const getApproval = (payload) => async (dispatch) => {
  const { id, name, action } = payload;
  try {
    dispatch(
      actionType(DocumentConstants.DOCUMENT_APPROVAL_REQUEST, {
        loading: true,
        id,
      })
    );
    const data = await DocumentService.approveOrDisapprove(payload);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    dispatch(
      actionType(DocumentConstants.DOCUMENT_APPROVAL_SUCCESS, {
        loading: false,
        id,
      })
    );
    toast.success(`${name} ${action} successfully.`);
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(
      actionType(DocumentConstants.DOCUMENT_APPROVAL_FAILURE, {
        loading: false,
        id,
      })
    );
    toast.error(message);
  }
};

export const getAttachedDocuments = () => async (dispatch) => {
  try {
    dispatch(actionType(DocumentConstants.FETCH_ATTACHED_DOCUMENT_REQUEST));
    const data = await DocumentService.getAllUserAttachedDocuments();
    if (data.status !== 200) {
      throw data;
    }
    const responseData = data.data;
    dispatch(
      actionType(
        DocumentConstants.FETCH_ATTACHED_DOCUMENT_SUCCESS,
        responseData
      )
    );
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(DocumentConstants.FETCH_ATTACHED_DOCUMENT_FAILURE));
    toast.error(message);
  }
};

export const attachedNewDocument = (payload) => async (dispatch) => {
  try {
    dispatch(actionType(DocumentConstants.ATTACH_DOCUMENT_REQUEST));
    const data = await DocumentService.attachedDocument(payload);
    if (data.status !== 200) {
      throw data;
    }
    const responseData = data.data;
    dispatch(
      actionType(DocumentConstants.ATTACH_DOCUMENT_SUCCESS, responseData)
    );
    dispatch(getAttachedDocuments());
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(DocumentConstants.ATTACH_DOCUMENT_FAILURE));
    toast.error(message);
  }
};

export const deleteAttachedDocument = (payload) => async (dispatch) => {
  const { id } = payload;
  try {
    dispatch(actionType(DocumentConstants.DELETE_ATTACHED_DOCUMENT_REQUEST));
    const data = await DocumentService.deleteAttachedDocument(id);
    if (data.status !== 200) {
      throw data;
    }
    const responseData = data.data;
    dispatch(
      actionType(
        DocumentConstants.DELETE_ATTACHED_DOCUMENT_SUCCESS,
        responseData
      )
    );
    dispatch(getAttachedDocuments());
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(DocumentConstants.DELETE_ATTACHED_DOCUMENT_FAILURE));
    toast.error(message);
  }
};

export const getAllCountries = () => async (dispatch) => {
  try {
    dispatch(actionType(DocumentConstants.ALL_COUNTRIES_REQUEST));
    const data = await DocumentService.getCountries();
    if (data.status !== 200) {
      throw data;
    }
    const responseData = data.data;
    dispatch(actionType(DocumentConstants.ALL_COUNTRIES_SUCCESS, responseData));
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(DocumentConstants.ALL_COUNTRIES_FAILURE));
    toast.error(message);
  }
};

export const getRequiredDocumentList =
  (isMisplacedDocument) => async (dispatch) => {
    try {
      dispatch(actionType(DocumentConstants.FETCH_REQUIRED_DOCUMENTS_REQUEST));
      const data = await DocumentService.getRequiredDocuments(
        isMisplacedDocument
      );
      console.log("getRequiredDocumentList ==> ", data);
      if (data.status !== 200) {
        throw data;
      }
      const responseData = data.data;
      dispatch(
        actionType(
          DocumentConstants.FETCH_REQUIRED_DOCUMENTS_SUCCESS,
          responseData
        )
      );
    } catch (error) {
      let message = ErrorHelper.getApiErrorMessage(error);
      dispatch(actionType(DocumentConstants.FETCH_REQUIRED_DOCUMENTS_FAILURE));
      toast.error(message);
    }
  };

export const updateDocumentTrackingStatus = (payload) => async (dispatch) => {
  try {
    dispatch(actionType(DocumentConstants.UPDATE_TRACKING_STATUS_REQUEST));
    const data = await DocumentService.updateTrackingStatus(payload);
    const responseData = data.data;
    dispatch(
      actionType(DocumentConstants.UPDATE_TRACKING_STATUS_SUCCESS, responseData)
    );
    toast.success("Document status updated successfully");
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(DocumentConstants.UPDATE_TRACKING_STATUS_ERROR));
    toast.error(message);
  }
};

export const userDocumentTrackingStatus = (payload) => async (dispatch) => {
  try {
    dispatch(actionType(DocumentConstants.UPDATE_TRACKING_STATUS_REQUEST));
    const data = await DocumentService.updateTrackingStatus(payload);
    const responseData = data.data;
    dispatch(
      actionType(DocumentConstants.UPDATE_TRACKING_STATUS_SUCCESS, responseData)
    );
    toast.success("Tracking status updated successfully");
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(DocumentConstants.UPDATE_TRACKING_STATUS_ERROR));
    toast.error(message);
  }
};

export const getUserDocumentTrackingStatus =
  (documentId) => async (dispatch) => {
    try {
      dispatch(actionType(DocumentConstants.FETCH_TRACKING_STATUS_REQUEST));
      const data = await DocumentService.getDocumentTrackingStatus(documentId);
      const responseData = data.data;
      dispatch(
        actionType(
          DocumentConstants.FETCH_TRACKING_STATUS_SUCCESS,
          responseData
        )
      );
    } catch (error) {
      let message = ErrorHelper.getApiErrorMessage(error);
      dispatch(actionType(DocumentConstants.FETCH_TRACKING_STATUS_ERROR));
      toast.error(message);
    }
  };
